import { render, staticRenderFns } from "./VSkeletonPos.vue?vue&type=template&id=44b37e65"
import script from "./VSkeletonPos.vue?vue&type=script&lang=js"
export * from "./VSkeletonPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b37e65')) {
      api.createRecord('44b37e65', component.options)
    } else {
      api.reload('44b37e65', component.options)
    }
    module.hot.accept("./VSkeletonPos.vue?vue&type=template&id=44b37e65", function () {
      api.rerender('44b37e65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/pos/pos/components/complements/VSkeletonPos.vue"
export default component.exports